export * from './projekt-archiviert.interface';
